import io from 'socket.io-client'
let socket

export const connect = () => {
  socket = io()
  console.log('Connecting socket.io...')
}

export const disconnect = () => {
  console.log('Disconnecting socket.io...')
  if(socket) socket.disconnect()
}


export const subscribeToDevices = (cb) => {
  if(!socket) return(true)

  socket.on('updateDevices', data => {
    console.log('[socket] updateDevices')
    console.log(JSON.stringify(data, null, 3))
    return cb(null, data.deviceList)
  })
}
